import * as yup from 'yup';

import { KASKOTYP } from '@/features/Sparten/shared/types';
import { getLastNYears } from '@/utils/dates/dates';

export const VorschadenSchema = yup.object({
  jahr: yup
    .string()
    .oneOf([...getLastNYears(5), ''])
    .required(),
  typ: yup
    .string()
    .oneOf([KASKOTYP.HAFTPFLICHT, KASKOTYP.TEILKASKO, KASKOTYP.VOLLKASKO])
    .required()
    .default(KASKOTYP.HAFTPFLICHT),
});

export type Vorschaden = yup.Asserts<typeof VorschadenSchema>;

export const vorschaedenSchema = yup
  .array()
  .default([] as Vorschaden[])
  .of(VorschadenSchema);
